/*
 * @Author: qinmengyuan
 * @Date: 2024-03-26 09:08:02
 * @LastEditors: qinmengyuan 2715025514@qq.com
 * @LastEditTime: 2024-08-19 18:27:26
 * @FilePath: \onetab\src\main.ts
 */
import Database from './lib/Database';
import { RaLoading } from '@rafter/pc';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'; // 引入它的 css
import VueVirtualScroller from 'vue-virtual-scroller'; // 引入它
import router from './router/index.js';
Database.create();

import { createApp } from 'vue';
import App from './App.vue';
// import "./assets/styles/theme.scss";
import './assets/font/font.css';
import './assets/styles/dark.css';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// eslint-disable

import '@rafter/pc/style.css';
import ClickOutside from './lib/clickoutside';

const app = createApp(App);

app.use(RaLoading);
app.use(router);
app.directive('clickoutside', ClickOutside);
app.use(VueVirtualScroller);
app.mount('#app');
